<template>
    <div>
        <div class="row pl-3 pr-1 data-row mx-0" :style="rowDetail ? 'border-bottom: none' : ''">
            <div class="px-1 col-2">
                <basic-info></basic-info>
            </div>
            <div class="px-1 col-2">
                <span class="small">{{ target.data.success }}</span>
                <i
                    v-if="!target.is_manual_entry"
                    class="ml-2 fa fa-caret-right cursor-pointer text-primary"
                    style="transition: all 0.4s;"
                    :class="{ 'rot-90': rowDetail }"
                    @click="rowDetail = !rowDetail"
                ></i>
            </div>
            <div class="px-1 col-2">
                <span class="small">{{
                    target.data.hasOwnProperty("results")
                        ? target.data.results.length
                        : target.data.attempts
                }}</span>
            </div>
            <div class="px-1 col-1">
                <span class="small">{{ success }}%</span>
            </div>
            <div class="px-1 col-4">
                <span class="small"
                    ><span v-if="isBaseline" class="font-weight-bold text-uppercase text-primary"
                        >Baseline</span
                    >
                    {{ target.notes ? target.notes : "none" }}</span
                >
            </div>
            <div class="px-1 col-1">
                <data-actions
                    @delete-tracker="$emit('delete-tracker')"
                    @edit-target="$emit('edit-target', $event)"
                    @close-details="$emit('close-details')"
                ></data-actions>
            </div>
        </div>
        <div class="row pl-3 pr-1 data-row mx-0" v-if="rowDetail" style="border-top:none;">
            <div class="col-12">
                <div class="row">
                    <div class="col-1"></div>
                    <div class="col-2">
                        <small><b>Item</b></small>
                    </div>
                    <div class="col-2">
                        <small><b>Prompt</b></small>
                    </div>
                    <div class="col-2">
                        <small><b>MO/Item present</b></small>
                    </div>
                    <div class="col-2">
                        <small><b>Flags</b></small>
                    </div>
                    <div class="col-2"></div>
                </div>
                <div class="row" v-for="(r, i) in target.data.results">
                    <div class="col-1">
                        <small>{{ i + 1 }}.</small>
                    </div>
                    <div class="col-2">
                        <small>{{ r.reinforcer }}</small>
                    </div>
                    <div class="col-2  mx-1">
                        <span class="d-flex" v-if="r.hasOwnProperty('result')">
                            <prompt
                                v-if="r.detailed_result"
                                :mini="true"
                                :prompt="[null, iconset, r.detailed_result]"
                            ></prompt>
                            <prompt v-else="" :mini="true" :prompt="[null, 6, r.result]"></prompt>
                        </span>
                    </div>
                    <div class="col-2">
                        <span class="small">{{
                            r.modifier && r.modifier.length ? r.modifier : ""
                        }}</span>
                    </div>
                    <div class="col-2">
                        <span class="small comma-list" v-for="w in r.parameters">{{ w }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Prompt from "../../ui/PromptIcon";
import BasicInfo from "./BasicInfo";
import DataActions from "./DataActions";

export default {
    name: "TrackerDataMand",
    inject: ["target", "isBaseline", "iconset"],
    data() {
        return {
            rowDetail: false,
        };
    },
    components: {
        Prompt,
        BasicInfo,
        DataActions,
    },
    computed: {
        success() {
            let results = _.get(this.target, "data.results", []);
            let count = results.length;
            if (Array.isArray(this.target.data.results)) {
                let successes = this.target.data.results.filter(r => r.result).length; //This applies to the Mand tracker
                if (count) {
                    return parseInt((100 * successes) / count);
                }
            }
            return 0;
        },
    },
};
</script>
